import { Component, inject, OnInit, Signal } from '@angular/core';
import { AlertComponent } from '../../common/alert/alert.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../components/content/content.component';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectBudgets, selectLoading } from '../../store/selectors/civic-budget.selectors';
import { loadBudgets } from '../../store/actions/civic-budget.actions';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { SessionService } from '../../services/ssession.service';
import { CivicBudgetAppEntityCivicBudgetRead } from '../../openapi';

@Component({
  selector: 'app-civic-budget-page',
  standalone: true,
  imports: [
    AlertComponent,
    BreadcrumbsComponent,
    ContentComponent,
    CommonModule,
    RouterLink,
    SpinnerComponent
  ],
  templateUrl: './civic-budget-page.component.html'
})
export class CivicBudgetPageComponent implements OnInit {

  private store$: Store = inject(Store);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public budgets: Signal<CivicBudgetAppEntityCivicBudgetRead[]> = this.store$.selectSignal(selectBudgets);

  public authed: boolean = SessionService.Authed();

  public ngOnInit(): void {
    this.store$.dispatch(loadBudgets({ force: true }));
  }
}
